module.exports = __webpack_public_path__ + "static/media/nasa.86730936.png";